
import {DataSourceMode, DropdownItem, LayoutProps} from "@mcleod/components";
import {StringUtil, UserSettings} from "@mcleod/core";
import {AutogenLayoutRateIndexControlPanel} from "./autogen/AutogenLayoutRateIndexControlPanel";

interface RateIndexControlLayoutProps extends LayoutProps {
    vendorId: string;
}

export class RateIndexControlPanel extends AutogenLayoutRateIndexControlPanel{
    private _vendorId: string;
    private truckstopVendorId = "I";
    private freightwavesVendorId = "F";


    constructor(props?: Partial<RateIndexControlLayoutProps>) {
        super(props);
        this._vendorId = props?.vendorId;
    }

    async onLoad() {
        this.mainDataSource.addAfterModeChangeListener(event =>{
            if(event.newMode === DataSourceMode.ADD) {
                if (this.mainDataSource.activeRow == null) {
                    return;
                }
                this.activeRow.setValues(this.getDefaultData());
            }
        });
        this.modifyLabelCaptionsAndFieldVisibility();
    }

    async postDataSources(vendorId: string): Promise<boolean> {
        try {
            this.mainDataSource?.activeRow?.set("vendor", vendorId);
            if(StringUtil.equalsIgnoreCase("F",vendorId)){
             if(this.mainDataSource.activeRow.get("service_timeout_duration") == undefined){
                 this.mainDataSource?.activeRow?.set("service_timeout_duration", 60);
             }
                this.mainDataSource?.activeRow?.set("spot_rate_type", "Y");
            }

            const mainPost = await this.mainDataSource.post();
            return true;
        } catch (error) {
            return false;
        }
    }

    private modifyLabelCaptionsAndFieldVisibility() {
         if(StringUtil.equalsIgnoreCase(this._vendorId,this.truckstopVendorId)){
            this.layoutRateIndexControlMainPanel.textboxDashboardUrl.visible = false;
            this.layoutRateOptions.switchContractRates.visible = false;
            this.layoutRateOptions.switchInternalRates.visible = false;
            this.layoutRateOptions.switchBilledRates.caption = "Display Paid Rates";
            this.layoutRateOptions.switchDisplaySpotRates.caption = "Display Posted Rates";
            this.layoutRateOptions.textboxCustomerId.visible = !this.layoutRateOptions.switchUseMarketRateFuelSurcharge.checked;
        }
        else if(StringUtil.equalsIgnoreCase(this._vendorId,this.freightwavesVendorId)){
            this.layoutRateIndexControlMainPanel.textboxIntegrationId.visible = false;
            this.layoutRateIndexControlMainPanel.textboxIntegrationId.required = false;
            this.layoutRateIndexControlMainPanel.textboxDashboardUrl.visible = false;
            this.layoutRateOptions.labelRateOptions.visible = true;
            this.layoutRateOptions.labelRateTypes.visible = false;
            this.layoutRateOptions.switchBilledRates.visible = false;
            this.layoutRateOptions.switchContractRates.visible = false;
            this.layoutRateOptions.switchInternalRates.visible = false;
            this.layoutRateOptions.switchDisplaySpotRates.visible = false;
            this.layoutRateOptions.switchUseMarketRateFuelSurcharge.visible = false;
            this.layoutRateOptions.textboxRateRequest.visible = false;
            this.layoutRateOptions.textboxRateRequest.required = false;
            this.layoutRateOptions.textboxCustomerId.visible = false;
            this.layoutRateIndexAdditionalOptionsPanel.textboxNumberOfReports.visible = false;
            this.layoutRateIndexAdditionalOptionsPanel.textboxMilesPerGallon.visible = false;
            this.layoutRateIndexAdditionalOptionsPanel.textboxSearchRange.visible = false;
            this.layoutRateOptions.switchAutoRateRetreival.marginLeft = 0;
        }
    }

    private getDefaultData() {
        if(StringUtil.equalsIgnoreCase(this._vendorId,this.truckstopVendorId)) {
            return this.activeRow.get("truckstop_default_values");
        }
        if(StringUtil.equalsIgnoreCase(this._vendorId,this.freightwavesVendorId)) {
            return this.activeRow.get("freightwaves_default_values");
        }
    }
}
